import React, { useEffect } from 'react';
import '../index.css';
import './CommonDialog.css';
import updateFailImage from '../assets/icons/error.png';
import { soundService } from '../services/SoundService.ts';

interface UpdateFailProps {
  onClose: () => void;
}

const UpdateFail: React.FC<UpdateFailProps> = ({ onClose }) => {
  useEffect(() => {
    soundService.playSound('error');
  }, []);

  return (
    <div className="common-dialog-container">
      <div className="common-dialog-content">
        <div className="common-dialog-image-container">
          <img src={updateFailImage} alt="Error" className="common-dialog-image" />
        </div>
        <div className="common-dialog-right-content">
          <span className="common-dialog-message message-text">
            バックアップに失敗しました。
          </span>
          <button 
            className="btn-common btn-large"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateFail;
